import { useContext } from 'react';
import { FHRequestContext } from 'contexts/fhrequest_context';

const useFHRequest = () => {
    return useContext(FHRequestContext);
};

export default useFHRequest;
